import { TotpMfaVerificationState } from '@pages/totp-mfa-verification/store/state/totp-mfa-verification.state';

export const totpMfaVerificationState = [TotpMfaVerificationState];
